module.exports = __webpack_public_path__ + "static/assets/a327bd3ac8576c62a1dd59efee4df3c4.svg";